import {
  OverrideStatusEnum,
  TripEventEnum,
  TripEventRead,
} from 'src/common/external/bambi-api/bambiApi';

const allEventTypes: TripEventEnum[] = [
  'status_en_route',
  'status_at_pickup',
  'status_transporting',
  'status_at_dropoff',
  'completion',
  'uncompletion',
  'cancellation',
  'uncancellation',
  'accept',
  'assign',
  'unassign',
  'lock',
  'unlock',
  'rejection',
  'unrejection',
  'activate_will_call',
  'update_pickup_at',
  'push_needs_at_pickup',
  'push_needs_transporting',
  'push_needs_dropoff',
  'push_needs_completed',
  'enter_pickup_geofence',
  'exit_pickup_geofence',
  'enter_dropoff_geofence',
  'exit_dropoff_geofence',
  'cancel_will_call_activation',
  'cancellation_request',
  'accept_cancellation_request',
  'reject_cancellation_request',
  'remove_cancellation_request',
];

export const editableStatusUpdateEvents: TripEventEnum[] = [
  'status_en_route',
  'status_at_pickup',
  'status_transporting',
  'status_at_dropoff',
  'completion',
];

export const editableTripEventEnumToOverrideStatusEnumMap: Partial<
  Record<TripEventEnum, OverrideStatusEnum>
> = {
  status_en_route: 'en route',
  status_at_pickup: 'at pickup',
  status_transporting: 'transporting',
  status_at_dropoff: 'at dropoff',
  completion: 'completed',
};

export const nonEditableStatusUpdateEvents = allEventTypes.filter(
  (eventType) => !editableStatusUpdateEvents.includes(eventType)
);

export function isManualStatusUpdateEvent(event: TripEventRead) {
  return !event.latitude || !event.longitude;
}
